import * as Sentry from '@sentry/vue';
import format from './format';

let translations = {};
let locale = 'pl';

const reportedMissing = new Set();

function reportMissing(key) {
  const fp = `${locale}:${key}`;
  if (reportedMissing.has(fp)) return;
  reportedMissing.add(fp);
  Sentry.captureMessage(`i18n missing: ${key}`, {
    level: 'warning',
    tags: { source: 'trans', locale, type: 'missing' },
  });
}

export default function trans(message, ...values) {
  const translation = translations[message];

  if (translation === undefined) {
    reportMissing(message);
  }

  if (values.length) {
    return format(translation || message, values);
  }

  return translation || message;
}

export function tag(strings, ...values) {
  return trans(strings.reduce((prev, next) => prev.concat(values.shift(), next)));
}

export function setTranslations(dictionary, lang) {
  translations = dictionary;
  if (lang) locale = lang;
}
